import { Package, Hammer, Layers, Zap, Droplets, Wrench, PaintBucket, HardHat } from "lucide-react";

export const RAPID_CATEGORIES = [
  { icon: Package, label: "Cement & plaster" },
  { icon: Hammer, label: "Steel & TMT" },
  { icon: Layers, label: "Plywood & boards" },
  { icon: Zap, label: "Electrical" },
  { icon: Droplets, label: "Plumbing & sanitary" },
  { icon: Wrench, label: "Hardware & fittings" },
  { icon: PaintBucket, label: "Paint & waterproofing" },
  { icon: HardHat, label: "Tools & safety" },
];

export const RAPID_BRANDS = [
  "UltraTech", "Ambuja", "SAIL", "Tata Tiscon", "JSW Neosteel", "Tata Wiron", "Tata Steel", "JSW Colouron+",
  "Century Ply", "Greenply", "Action Tesa", "Merino", "Polycab", "Havells", "Legrand", "Anchor", "Philips", "Astral", "Asian Paints", "Bosch",
];

export const RAPID_PERKS = [
  { title: "Bulk prices, no haggling", desc: "Tiered rates shown on every product and applied automatically in the cart." },
  { title: "1% Rapid Cash", desc: "Earn on every order when you're logged in. Use it on orders above ₹500." },
  { title: "2% assured cashback", desc: "On every order above ₹50,000 — credited straight to your Rapid wallet." },
  { title: "Pay on delivery", desc: "Check the material at site first, then pay by cash or UPI." },
];

export const RAPID_TRUST = [
  { title: "Sourced from brands and mills", desc: "We buy from manufacturers and authorised distributors only. Steel arrives with its mill test certificate." },
  { title: "Check before you pay", desc: "Scan the QR on the invoice to see batch, grade and source. If anything looks wrong, don't pay." },
  { title: "Weight you can trust", desc: "Steel is weighed at dispatch and the weigh-slip travels with your order." },
];

export const RAPID_QUICK_ITEMS = ["OPC 53 cement", "TMT 12 mm", "Binding wire", "BWP plywood", "1.5 sq mm wire", "CPVC pipe"];

const NCR_PREFIXES = ["11", "121", "122", "201"];

export function checkRapidPincode(pin) {
  const p = String(pin || "").trim();
  if (!/^\d{6}$/.test(p)) return { ok: false, status: "invalid", message: "Enter a valid 6-digit pincode" };
  if (NCR_PREFIXES.some((x) => p.startsWith(x))) return { ok: true, status: "60min", message: "Delhi NCR — delivered in 60 minutes" };
  return { ok: false, status: "soon", message: "Not in a Rapid zone yet — Iron Byte Bulk still delivers pan-India in 3–8 days" };
}

export function etaLabel(minutes = 60) {
  const t = new Date(Date.now() + minutes * 60000);
  return t.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit" });
}
